import Vue from 'vue';

export interface BaseComponentData<T = any> {
  isLoading: boolean;
  data: T | null;
  error: Error | undefined;
}

export const BaseComponentOption = Vue.extend({
  data() {
    return {
      isLoading: true,
      data: null,
      error: undefined,
    };
  },
  computed: {
    slotProps(): BaseComponentData {
      return {
        isLoading: this.isLoading,
        data: this.data,
        error: this.error,
      };
    },
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch(): Promise<void> {
      this.isLoading = true;
      this.error = undefined;

      try {
        const data = await this.fetchData();
        this.data = data;

        this.emitUpdateEvent({ data });
      } catch (error) {
        this.error = error;
      } finally {
        this.isLoading = false;
      }
    },

    fetchData<DataT = any>(): Promise<DataT> {
      throw new Error('Not implemented');
    },

    emitUpdateEvent(...eventPayload: any[]): void {
      this.$emit('update', ...eventPayload);
    },
  },
  render(h) {
    const slotProps = this.slotProps as any;

    const vm = this.$scopedSlots.default && this.$scopedSlots.default(slotProps);
    return (vm && vm[0]) || h('div');
  },
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const extendBase = (options: {
  data: Function;
  methods: {
    fetchData: <DataT = any>() => Promise<DataT>;
    [k: string]: (() => any);
  };
  computed: {
    [k: string]: (() => any);
  };
}) => BaseComponentOption.extend({
  ...options,
  data() {
    return {
      ...(options.data ? options.data.call(this) : {}),
    };
  },
});
